const styles = (theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: 0,
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});

export default styles;
